export const reduxKey = '@@compliantLocalStorage';

export enum CompliantLocalStorageKeys {
  MURO = 'muro',
  RECENT_COLORS = 'custombox.recent.colors',
  INTENTS = 'intents',
  INTENTS_OTHER = 'intents_other',
  STATUS_SUBMIT_COUNTER = 'statusUpdateSubmitCounter',
  CHATDB = 'chatDB',
  EDITOR_DRAFTS = 'editorDrafts',
  TIPTAP_DRAFTS = 'tiptapDrafts',
  NC_DELETE_ON_REPLY = 'ncDeleteOnReply',
  DO_NOT_SHOW_AGAIN = 'confirm.modal.do.not.show',
  SOCIAL = 'social',
  DREAMUP_ANON_FORM = 'dreamup_anon_form',
  PWA_NOTIFICATIONS = 'pwa_notifications', // whether PWA push notifications are enabled
  BOOST_PROMO_LAST_SEEN = 'boost_promo_last_seen', // last time the boost promo was shown
}

export enum CompliantCategories {
  ESSENTIAL = 'essential',
  FUNCTIONAL = 'functional',
}

export const LocalStorageCategoryTypeConfig = {
  // essential
  [CompliantLocalStorageKeys.INTENTS]: CompliantCategories.ESSENTIAL,
  [CompliantLocalStorageKeys.INTENTS_OTHER]: CompliantCategories.ESSENTIAL,
  [CompliantLocalStorageKeys.CHATDB]: CompliantCategories.ESSENTIAL,
  [CompliantLocalStorageKeys.DO_NOT_SHOW_AGAIN]: CompliantCategories.ESSENTIAL,
  [CompliantLocalStorageKeys.SOCIAL]: CompliantCategories.ESSENTIAL,
  [CompliantLocalStorageKeys.PWA_NOTIFICATIONS]: CompliantCategories.ESSENTIAL,

  // functional
  [CompliantLocalStorageKeys.MURO]: CompliantCategories.FUNCTIONAL,
  [CompliantLocalStorageKeys.RECENT_COLORS]: CompliantCategories.FUNCTIONAL,
  [CompliantLocalStorageKeys.STATUS_SUBMIT_COUNTER]:
    CompliantCategories.FUNCTIONAL,
  [CompliantLocalStorageKeys.EDITOR_DRAFTS]: CompliantCategories.FUNCTIONAL,
  [CompliantLocalStorageKeys.NC_DELETE_ON_REPLY]:
    CompliantCategories.FUNCTIONAL,
  [CompliantLocalStorageKeys.BOOST_PROMO_LAST_SEEN]:
    CompliantCategories.FUNCTIONAL,
};
